// ----------------------------------------------------------------------------
// Template: Index
// ----------------------------------------------------------------------------
// Home Page Template
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/hero-banner/hero-banner';
import 'sections/hero-banner-brand/hero-banner-brand';
import 'sections/hero-banner-conversion/hero-banner-conversion';
import 'sections/intro-block/intro-block';
import 'sections/collection-list/collection-list';
import 'sections/announcement-bar/announcement-bar';
import 'sections/icon-block/icon-block';
import 'sections/content-panel/content-panel';
import 'sections/faqs/faqs';
import 'sections/testimonial/testimonial';
import 'sections/featured-collection/featured-collection';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/footer/footer';

// Styles
